export default __webpack_public_path__ + "static/Entenda0092-ad6681eb05570be70fadcbf41f30ceea.jpg";